(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a9-variant-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('a9-variant-content')) {
    class A9VariantContent extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-a9-config]').textContent);
        this.visibility = this.querySelector('[data-a9-visibility]');
        this.abortController?.abort();
        this.abortController = new AbortController();
        document.addEventListener('variant:change', (event) => {
          if (event.target.getAttribute('id') !== this.config.formId) return;
          this.applyVariant(event.detail?.variant);
        }, { signal: this.abortController.signal });
        document.addEventListener('shopify:section:load', () => {
          this.updateNavigation(this.mode === true);
        }, { signal: this.abortController.signal });
        const picker = [...document.querySelectorAll('variant-picker')].find(
          (element) => element.getAttribute('form-id') === this.config.formId
        );
        this.applyVariant(picker?.selectedVariant ?? this.config.initialVariant);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      isAlternate(variant) {
        if (!variant?.id) return false;
        if (this.config.alternateVariantId) {
          return String(variant.id) === this.config.alternateVariantId;
        }
        const text = [...(variant.options || []), variant.sku || ''].join(' ');
        return Boolean(this.config.alternateToken && text.includes(this.config.alternateToken));
      }

      updateNavigation(alternate) {
        const navigation = document.getElementById(`shopify-section-${this.config.prefix}__menu_Wg9GYV`);
        navigation?.querySelectorAll('[data-a9-nav-link]').forEach((link) => {
          link.setAttribute('href', alternate ? link.dataset.alternateHref : link.dataset.originalHref);
          link.textContent = alternate ? link.dataset.alternateText : link.dataset.originalText;
        });
      }

      applyVariant(variant) {
        if (!variant?.id) return;
        const alternate = this.isAlternate(variant);
        const hidden = alternate ? this.config.originalSections : this.config.alternateSections;
        const ids = hidden.map(
          (key) => `${this.config.prefix}__${key.trim()}`
        );
        this.visibility.textContent = ids.map(
          (id) => `#${CSS.escape(`shopify-section-${id}`)} { display: none !important; }`
        ).join('\n');
        this.updateNavigation(alternate);
        if (this.mode !== alternate) {
          this.mode = alternate;
          requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        }
      }
    }
    customElements.define('a9-variant-content', A9VariantContent);
  }
  } catch(e) { console.error(e); }
})();

})();
